import { notesApi } from '@/lib/notesApi';

// dash: stock dashboard figures (tag admins without money rights get their whole brand, without values).
export const loadApprovals = async (dash = false) => (await notesApi.get('/notes/tag-workspace/approvals', { params: dash ? { dash: true } : undefined })).data || [];
export const returnFromApproval = async (ids) => (await notesApi.post('/notes/tag-workspace/approvals/return', { item_ids: ids })).data;

// Pre-fill for selling pieces of one customer from their approval(s): customer, sales persons, rate card, gold rate, item rates.
export function approvalLock(approvals, ids) {
  const set = new Set(ids);
  const hit = approvals.filter((a) => a.items.some((i) => set.has(i.id)));
  if (!hit.length) return null;
  const a = hit[0];
  if (a.marketing) hit.splice(0, hit.length, ...hit.filter((x) => x.marketing && x.sales_ids?.[0] === a.sales_ids?.[0]));
  return {
    mat_opts: a.marketing ? undefined : a.mat_opts, marketing: !!a.marketing, customer_id: a.marketing ? '' : a.customer_id, customer_name: a.marketing ? '' : a.customer_name, sales_ids: a.sales_ids || [], rate_card_id: a.rate_card_id || '', gold_rate_100: a.gold_rate_100,
    items: hit.flatMap((x) => x.items.filter((i) => set.has(i.id)).map((i) => ({ ...i, _card: x.rate_card_id || '' }))), numbers: hit.map((x) => x.number).join(', '),
  };
}

// Approvals → flat lines (item + its approval), like soldLines for sales.
export const approvalLines = (list) => list.flatMap((a) => a.items.map((i) => ({ ...i, sale: a, approval: a })));

export const approvalAge = (iso) => Math.max(0, Math.floor((Date.now() - new Date(iso).getTime()) / 86400000));
// Overdue = older than the number of days set on the approval (optional).
export const isOverdue = (a) => Number(a.due_days) > 0 && approvalAge(a.created_at) > Number(a.due_days);
export const setApprovalDueDays = async (id, days) => (await notesApi.patch(`/notes/tag-workspace/approvals/${id}/due-days`, { due_days: days })).data;
